module.exports = __webpack_public_path__ + "static/img/SFG116_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SFG116_1.png
// module id = w4fB
// module chunks = 0